// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, browser:true, react:true*/
import React, {useEffect, useContext, useState, Fragment, useRef} from 'react';
import cn from 'classnames';
import {useHistory, useLocation} from 'react-router-dom';
import etask from 'zetask';
import zutil from 'zutil';
import {Select} from '../lib/select';
import {Button} from '../../../shared/button';
import country_styles from '../pages/hola.org/countries/countries.module.less';
import {Settings_context} from '../settings_ctx';
import {use_countries} from '../ui/forms/use_countries';
// @ts-ignore
import {App_context} from '../context.js';
// @ts-ignore
import {fetch} from '/util/fetch.js';
// @ts-ignore
import {perr, perr_www_visit} from '../util.js';
// @ts-ignore
import {e2s} from '/util/zerr.js';
import {Editor} from '../../../shared/editor/editor';
import styles from './premuim_support_form.module.less';

const hola_products = ['Chrome extension', 'Opera extension', 'Edge extension',
    'Hola browser', 'Windows desktop app', 'MacOS desktop app', 'Android app',
    'iOS app', 'Amazon Fire TV & Stick app', 'WebOS (LG) app', 'Other',
].map(v=>({title: v, value: v}));
const reasons = [{
  title: 'My Hola is not working properly',
  value: 'hola_isnt_working',
}, {
  title: `I'm having an issue with my subscription, payments, or account`,
  value: 'subscription',
}, {
  title: 'I have a general question, feedback or a feature request',
  value: 'general',
// }, {
//    title: 'I want to request a refund',
//    value: 'refund',
}];

const Dynamic_text_area = ({value, on_change, name, placeholder, label, cls}
  :{value: any, on_change: any, name: any, label?: string,
    placeholder?: string, cls?: string})=>{
  const area_ref = useRef();
  const title = label || 'Label';
  const change_height = el=>{
      el.style.height = 'auto';
      el.style.height = el.value &&
        el.scrollHeight>104 ? el.scrollHeight+'px' : '104px';
  };
  const on_change_plus_h = ev=>{
      ev.persist();
      change_height(ev.target);
      on_change(ev);
  };
  useEffect(()=>{
      if (area_ref.current)
          change_height(area_ref.current);
  }, [area_ref.current]);
  return <Fragment>
    <p className={cls}>{title}</p>
    <textarea value={value} name={name} ref={area_ref}
      onChange={on_change_plus_h} className={cn('hola_input')}
      placeholder={placeholder}/>
  </Fragment>;
};

interface i_premium_support_form_props {
    title: string;
    subtitle: string;
}

export const Premium_support_form = (props: i_premium_support_form_props)=>{
    const {title, subtitle} = props;
    // @ts-ignore
    const {user} = useContext(App_context);
    const {theme} = useContext(Settings_context);
    const history = useHistory();
    const location = useLocation() as any;
    const email = zutil.get(user, 'emails.0.value') ?? '';
    const [data, set_data] = useState({
        email, important: location.state?.important ?? '',
        reference: '', problem: '', country: '',
        site_country: '', any_privacy: '',
        access: '', reason: '', product: '',
    });
    const {countries} = use_countries('f32', cn(styles.flag_wrap, theme.root),
        country_styles.flag_icon, null, true);
    const show_product = data.reason=='hola_isnt_working';
    const subscription = data.reason=='subscription';
    const general = data.reason=='general';
    const refund = data.reason=='refund';
    const vulnerability = data.reason=='vulnerability';
    const [loading, set_loading] = useState(false);
    const is_ok = data.email && data.problem && (show_product && data.country
        && data.site_country && data.product || subscription && data.reference
        || general || vulnerability);
    const on_change = ev=>{
        set_data({...data, [ev.target.name]: ev.target.value});
    };
    const on_select_reason = (name, value)=>{
        set_data({...data, [name]: value});
        if (error)
            set_error('');
    };
    const on_select = (name, value)=>{
        set_data({...data, [name]: value});
        if (error)
            set_error('');
    };
    const on_open = ()=>{
      if (error)
          set_error('');
    };
    const on_report = ev=>{
        ev.preventDefault();
        etask(function*(){
            this.finally(()=>{ set_loading(false); });
            set_loading(true);
            set_error('');
            perr({id: 'www_premium_support_report_click_submit'});
            try {
                yield fetch('/premium_support', {method: 'POST', body: data});
                perr({id: 'www_premium_support_report_success'});
                history.push(`/premium_support_complete?email=${data.email}`);
            } catch(e){
                set_error('We\'ve encountered an error. '+
                    'Please try again later');
                perr({id: 'www_premium_support_report_err',
                    info: {err: e2s(e)}});
            }
        });
    };
    const [error, set_error] = useState('');
    useEffect(()=>{
        perr_www_visit({id: `www_premium_support_visit`, user});
    }, []);
    return <div className={theme.root}>
      <div className={cn(styles.page, theme.container)}>
        <div className={cn(styles.container, styles.mb_xs)}>
          <div className={styles.form_header}>
            <h1 className={cn(theme.H5, theme.color_n700, styles.mb_s)}>
              {title}</h1>
            <p className={cn(theme.p2, theme.reg, theme.color_n700)}>
              {subtitle}</p>
          </div>

          <div>
            <div className={styles.mt_l}>
              <p className={cn(theme.p5, theme.med,
                theme.color_n600, styles.mb_xs)}>
                Your email*</p>
              <input value={data.email} name="email" onChange={on_change}
                type="text" className={cn('hola_input')}
                placeholder="Enter your Email"/>
            </div>

            <div className={styles.mt_l}>
              <p className={cn(theme.p5, theme.med,
                theme.color_n600, styles.mb_xs)}>
                How can we help?*</p>
              <Select on_select={on_select_reason} name="reason"
                title="Select your issue" items={reasons} is_error={!!error}
                value={data.reason} on_open={on_open}
                class_name={styles.select}/>
            </div>

            {subscription && <div className={styles.mt_l}>
              <p className={cn(theme.p5, theme.med,
                theme.color_n600, styles.mb_xs)}>
                Reference/order number of the invoice*</p>
              <input value={data.reference} name="reference"
                onChange={on_change}
                type="text" className={cn('hola_input')}
                placeholder="Type reference/order number"/>
            </div>}

            {show_product && <Fragment>
              <div className={styles.mt_l}>
                <p className={cn(theme.p5, theme.med,
                  theme.color_n600, styles.mb_xs)}>
                  Hola product*</p>
                <Select on_select={on_select} name="product"
                  title="Choose a product"
                  items={hola_products} is_error={!!error}
                  value={data.product} on_open={on_open}
                  class_name={styles.select}/>
                </div>

                <div className={styles.mt_l}>
                <p className={cn(theme.p5, theme.med,
                  theme.color_n600, styles.mb_xs)}>
                  What country are you physically located in?*</p>
                <Select on_select={on_select} name="country"
                  tag_style={true}
                  title="Choose country" items={countries} is_error={!!error}
                  value={data.country} on_open={on_open}
                  class_name={styles.select}/>
              </div>

              <div className={styles.mt_l}>
                <p className={cn(theme.p5, theme.med,
                  theme.color_n600, styles.mb_xs)}>
                  Which location are you trying to connect to?*</p>
                <Select on_select={on_select} name="site_country"
                  tag_style={true}
                  title="Choose country" items={countries} is_error={!!error}
                  value={data.site_country} on_open={on_open}
                  class_name={styles.select}/>
              </div>
            </Fragment>}

            {data.reason &&
            <div className={styles.mt_l}>
              <Dynamic_text_area value={data.problem}
                name="problem"
                cls={cn(theme.p5, theme.med, theme.color_n600, styles.mb_xs)}
                label="Please describe the issue in detail*"
                placeholder="Tell us a bit more about it"
                on_change={on_change}/>
            </div>}

            <div className={styles.mt_l}>
            {error && <p className="report-error">{error}</p>}
            {!refund && <Button round cls={styles.submit}
              disabled={!is_ok||loading}
              on_click={on_report} arrow caption="Submit"/>}
            </div>
          </div>
        </div>
      </div>
    </div>;
};

interface i_premium_support_form_editor_props {
    value: i_premium_support_form_props;
    on_change: (new_val: i_premium_support_form_props)=>void;
}

export const Premium_support_form_editor = (
{value, on_change}: i_premium_support_form_editor_props)=>{
    return <Editor value={value} on_change={on_change}
      editors={[
        {key: 'title', label: 'Title (h1)', type: 'text'},
        {key: 'subtitle', label: 'Subtitle', type: 'text'},
      ]}/>;
};
